// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { WSClient } from '@ay-nestjs/share-client';
export let wsc = new WSClient();
// 53fb7ff79829206cb2b047a4fcaf007910069123b135c5cee1f29f291542ad9a
